/**
 * @generated SignedSource<<997729eca018a5fbb786cb8bdf246905>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookingType = "DINING" | "LESSON" | "STANDARD";
export type SlotAvailability = "ACCESSIBLE" | "ACCESSIBLE_BOOKING" | "AVAILABLE" | "AVAILABLE_AFTER_START" | "BLOCKED" | "BLOCKED_BY_BLOCK" | "BLOCKED_BY_BOOKING" | "BLOCKED_BY_EVENT" | "FREE" | "UNAVAILABLE";
export type CourseAndDurationControlQuery$variables = {
  agendaId: string;
  bookingId?: string | null | undefined;
  bookingType: BookingType;
  memberId: string;
  slotId: string;
  startTime: string;
};
export type CourseAndDurationControlQuery$data = {
  readonly node: {
    readonly agenda?: {
      readonly facility: {
        readonly durations: ReadonlyArray<number | null | undefined> | null | undefined;
      };
    };
    readonly course?: {
      readonly courseBucket: {
        readonly id: string;
      } | null | undefined;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly name: string;
    };
    readonly endSlotOptions?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly availability: SlotAvailability;
          readonly time: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly id?: string;
    readonly time?: string;
    readonly " $fragmentSpreads": FragmentRefs<"BucketDurationControlNode" | "CourseControlNode" | "useValidDurationsNode">;
  } | null | undefined;
};
export type CourseAndDurationControlQuery = {
  response: CourseAndDurationControlQuery$data;
  variables: CourseAndDurationControlQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agendaId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bookingId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bookingType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slotId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startTime"
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "slotId"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durations",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v12 = [
  {
    "kind": "Variable",
    "name": "bookingId",
    "variableName": "bookingId"
  },
  {
    "kind": "Variable",
    "name": "bookingType",
    "variableName": "bookingType"
  },
  {
    "kind": "Variable",
    "name": "memberId",
    "variableName": "memberId"
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "availability",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": (v12/*: any*/),
  "concreteType": "EndSlotOptionsConnection",
  "kind": "LinkedField",
  "name": "endSlotOptions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EndSlotOptionsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "durationMins",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowedPlayerCounts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSlot",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            (v8/*: any*/),
            (v13/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CourseAndDurationControlQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BucketDurationControlNode"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CourseControlNode"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useValidDurationsNode"
              },
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Agenda",
                "kind": "LinkedField",
                "name": "agenda",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Facility",
                    "kind": "LinkedField",
                    "name": "facility",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Course",
                "kind": "LinkedField",
                "name": "course",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CourseBucket",
                    "kind": "LinkedField",
                    "name": "courseBucket",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v12/*: any*/),
                "concreteType": "EndSlotOptionsConnection",
                "kind": "LinkedField",
                "name": "endSlotOptions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EndSlotOptionsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeSlot",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "TimeSlot",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "CourseAndDurationControlQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isNode"
          },
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Agenda",
                "kind": "LinkedField",
                "name": "agenda",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Facility",
                    "kind": "LinkedField",
                    "name": "facility",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Course",
                "kind": "LinkedField",
                "name": "course",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Facility",
                    "kind": "LinkedField",
                    "name": "facility",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PublicBookingPermissionSet",
                        "kind": "LinkedField",
                        "name": "publicBookingPermissionSet",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "customerCanSelectCourt",
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityCopyOverrides",
                        "kind": "LinkedField",
                        "name": "copyOverrides",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NounOverride",
                            "kind": "LinkedField",
                            "name": "course",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "singular",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CourseBucket",
                    "kind": "LinkedField",
                    "name": "courseBucket",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "agendaId",
                            "variableName": "agendaId"
                          },
                          {
                            "kind": "Variable",
                            "name": "startsAt",
                            "variableName": "startTime"
                          }
                        ],
                        "concreteType": "SlotDurations",
                        "kind": "LinkedField",
                        "name": "slotDurations",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TimeSlot",
                            "kind": "LinkedField",
                            "name": "startSlot",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Course",
                                "kind": "LinkedField",
                                "name": "course",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v14/*: any*/),
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "maxDurationMins",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "TimeSlot",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9250cf1cd71b991189d8018020e8de15",
    "id": null,
    "metadata": {},
    "name": "CourseAndDurationControlQuery",
    "operationKind": "query",
    "text": "query CourseAndDurationControlQuery(\n  $slotId: ID!\n  $agendaId: ID!\n  $startTime: Time!\n  $bookingType: BookingType!\n  $memberId: ID!\n  $bookingId: ID\n) {\n  node(id: $slotId) {\n    __typename\n    ...BucketDurationControlNode\n    ...CourseControlNode\n    ... on TimeSlot {\n      ...useValidDurationsNode\n      id\n      time\n      agenda {\n        facility {\n          durations\n          id\n        }\n        id\n      }\n      course {\n        id\n        courseBucket {\n          id\n        }\n        name\n        description\n      }\n      endSlotOptions(bookingId: $bookingId, bookingType: $bookingType, memberId: $memberId) {\n        edges {\n          node {\n            time\n            availability\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment BucketDurationControlNode on Node {\n  __isNode: __typename\n  ...useGetValidCourseAndDurationSelections_Node\n}\n\nfragment CourseControlNode on Node {\n  __isNode: __typename\n  ... on TimeSlot {\n    ...useGetCourseOptionsFromValidCustomerBookingSelections_TimeSlot\n    id\n    time\n    agenda {\n      id\n    }\n    endSlotOptions(bookingId: $bookingId, bookingType: $bookingType, memberId: $memberId) {\n      edges {\n        durationMins\n        allowedPlayerCounts\n        node {\n          id\n          time\n          availability\n        }\n      }\n    }\n    course {\n      id\n      name\n      description\n      facility {\n        publicBookingPermissionSet {\n          customerCanSelectCourt\n          id\n        }\n        copyOverrides {\n          course {\n            singular\n          }\n        }\n        id\n      }\n      courseBucket {\n        id\n        slotDurations(agendaId: $agendaId, startsAt: $startTime) {\n          startSlot {\n            id\n            time\n            endSlotOptions(bookingId: $bookingId, bookingType: $bookingType, memberId: $memberId) {\n              edges {\n                durationMins\n                allowedPlayerCounts\n                node {\n                  id\n                  time\n                  availability\n                }\n              }\n            }\n          }\n          maxDurationMins\n        }\n      }\n    }\n  }\n}\n\nfragment useGetCourseOptionsFromValidCustomerBookingSelections_TimeSlot on TimeSlot {\n  id\n  endSlotOptions(bookingId: $bookingId, bookingType: $bookingType, memberId: $memberId) {\n    edges {\n      durationMins\n      allowedPlayerCounts\n      node {\n        availability\n        id\n      }\n    }\n  }\n  course {\n    id\n    name\n    description\n    facility {\n      publicBookingPermissionSet {\n        customerCanSelectCourt\n        id\n      }\n      copyOverrides {\n        course {\n          singular\n        }\n      }\n      id\n    }\n    courseBucket {\n      id\n      slotDurations(agendaId: $agendaId, startsAt: $startTime) {\n        startSlot {\n          id\n          time\n          course {\n            id\n            name\n            description\n          }\n          endSlotOptions(bookingId: $bookingId, bookingType: $bookingType, memberId: $memberId) {\n            edges {\n              durationMins\n              allowedPlayerCounts\n              node {\n                availability\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment useGetValidCourseAndDurationSelections_Node on Node {\n  __isNode: __typename\n  ...useValidDurationsNode\n  ... on TimeSlot {\n    id\n    agenda {\n      id\n    }\n    time\n    course {\n      id\n      name\n      facility {\n        publicBookingPermissionSet {\n          customerCanSelectCourt\n          id\n        }\n        id\n      }\n      courseBucket {\n        id\n        slotDurations(agendaId: $agendaId, startsAt: $startTime) {\n          startSlot {\n            id\n            course {\n              id\n              name\n            }\n            endSlotOptions(bookingId: $bookingId, bookingType: $bookingType, memberId: $memberId) {\n              edges {\n                durationMins\n                allowedPlayerCounts\n                node {\n                  id\n                  time\n                  availability\n                }\n              }\n            }\n          }\n          maxDurationMins\n        }\n      }\n    }\n  }\n}\n\nfragment useValidDurationsNode on Node {\n  __isNode: __typename\n  ... on TimeSlot {\n    endSlotOptions(bookingId: $bookingId, bookingType: $bookingType, memberId: $memberId) {\n      edges {\n        durationMins\n        allowedPlayerCounts\n        node {\n          id\n          time\n          availability\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9e2b6b639de26df2bcf8003e469e7485";

export default node;
